const getBoxIndex = (allBoxes, boxId, shipments) => {
  const shipment = shipments?.find(({ boxes_info }) =>
    boxes_info?.some(({ id }) => id === boxId)
  );

  if (!shipment) return -1

  const index = shipment.boxes_info?.findIndex(box => box.id === boxId);
  if (index === -1) {
    shipments?.boxes_info?.length;
  }
  return index;
};

export const getNewBoxIndex = (shipments, shipmentId) => {
  const shipment = shipments?.find(({ amazon_shipment_id }) => amazon_shipment_id === shipmentId);
  if (!shipment) return -1;

  return shipment.boxes_info?.length;  
};

export default getBoxIndex;
